import React from 'react';
import { CLASSNAME_PREFIX, TRANSLATION_CONTEXT } from '../componentConfig';
import './VerificationRejected.scss';

export var VerificationRejectedInfo = function VerificationRejectedInfo(_ref) {
  var t = _ref.t,
      reminderCountdown = _ref.reminderCountdown;
  return React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-account-verification__info' },
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-account-verification__unverified' },
      t(TRANSLATION_CONTEXT)('accountVerification.rejected.documentsRejected')
    ),
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-account-verification__spaced' },
      t(TRANSLATION_CONTEXT)('accountVerification.rejected.documentsRejectedReason')
    ),
    reminderCountdown && React.createElement(
      'p',
      { className: CLASSNAME_PREFIX + '-account-verification__unverified' },
      t(TRANSLATION_CONTEXT)('accountVerification.rejected.documentsRejectedAlreadyUploadedInfo')
    )
  );
};

export var VerificationRejectedAction = function VerificationRejectedAction(_ref2) {
  var t = _ref2.t,
      links = _ref2.links;
  return links ? React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-account-verification__info' },
    React.createElement(
      'a',
      {
        className: CLASSNAME_PREFIX + '-account-verification-manual-upload__link',
        target: 'blank',
        href: links.manualVerification
      },
      t(TRANSLATION_CONTEXT)('accountVerification.rejected.documentsRejectedManualUpload')
    )
  ) : null;
};